import React, { Component, Fragment } from 'react'
import { connect } from 'react-redux'
import moment from 'moment'
import numeral from 'numeral'

import { formatcoin, getDivisa } from '../../utils/helpers'

import Modal from '../Shared/Modal'
import ModalHeader from '../Shared/ModalHeader'
import ModalButtonStrip from '../Shared/ModalButtonStrip'
import ModalBody from '../Shared/ModalBody'
import ModalFooter from '../Shared/ModalFooter'
import BoxButton from '../Layout/BoxButton'

import Box from '../Layout/Box'

import {
    showHideModalSummaryCotizaciones,
    registerSolicitudCotizaciones,
    updateInputs
} from '../../actions/externoscotizaciones'




class ModalSummaryCotizaciones extends Component {


    handleCloseModal = () => {

        const modal = document.getElementById('modalSummaryCotizaciones')
        modal.classList.remove('fadeIn')
        modal.classList.add('fadeOut')

        const modalDialog = document.querySelector(`#modalSummaryCotizaciones .modal-dialog`)
        modalDialog.classList.remove('zoomIn')
        modalDialog.classList.add('zoomOut')

        setTimeout(() => this.props.showHideModalSummaryCotizaciones(false), 300)
    }


    render() {

        const { modalSummaryCotizaciones, divisas } = this.props

        if (!modalSummaryCotizaciones.get('show')) {
            return null
        }

        const solicitud = modalSummaryCotizaciones.getIn(['data', 'solicitud'])
        const solicitud_id = solicitud.get('id')
        const cotizaciones = solicitud.get('cotizaciones')  

        const moneda = cotizaciones ? cotizaciones.first().get('moneda') : 'COP'        
        const divisa = getDivisa(divisas, moneda)

        
        let cont_items = 0


        return(
            <Modal id="modalSummaryCotizaciones" show={ true } ZIndex={ 2000 }>

                <ModalHeader title={ `Subir cotización` } onClose={ e => this.handleCloseModal(e, "modalSummaryCotizaciones") } />
                <ModalButtonStrip>

                    <BoxButton
                        name="check"
                        title="Enviar cotización"
                        onClick={ () => this.props.registerSolicitudCotizaciones(solicitud_id) }
                    />

                </ModalButtonStrip>
                <ModalBody>
                    <div style={{ width: 'Calc(100vw - 32px)', height: 'Calc(100vh - 117px)' }}>
                        <div className="row">
                            <div className="col-md-6">
                                <div className="form-group">
                                    <label className="control-label">Responsable compras</label>
                                    <input type="text" className="form-control input-sm" value={solicitud.getIn(['responsable_compras', 'fullname'])} disabled />
                                </div>
                            </div>
                            <div className="col-md-3">
                                <div className="form-group">
                                    <label className="control-label">Correo</label>
                                    <input type="text" className="form-control input-sm" value={solicitud.getIn(['responsable_compras', 'email'])} disabled />
                                </div>
                            </div>
                            <div className="col-md-3">
                                <div className="form-group">
                                    <label className="control-label">Extensión</label>
                                    <input type="text" className="form-control input-sm" value={solicitud.getIn(['responsable_compras', 'extension'])} disabled />
                                </div>
                            </div>
                        </div>


                        <div className="row">
                            <div className="col-md-7">
                                <div className="form-group">
                                    <label className="control-label">Proyecto/Evento/Actividad</label>
                                    <input type="text" className="form-control input-sm" value={solicitud.getIn(['proyecto_evento'])} disabled/>
                                </div>
                            </div>
                            <div className="col-md-2">
                                <div className="form-group">
                                    <label className="control-label">No. Solicitud</label>
                                    <input type="text" className="form-control input-sm" value={solicitud_id} disabled/>
                                </div>
                            </div>
                            <div className="col-md-3">
                                <div className="form-group">
                                    <label className="control-label">Fecha solicitud</label>
                                    <input type="text" className="form-control input-sm" value={moment(solicitud.getIn(['created_at'])).format('DD/MM/YYYY')} disabled/>
                                </div>
                            </div>
                        </div>

                        <div className="row">

                            <div className="col-md-9">
                                <div className="alert alert-info">
                                    Usted podrá cotizar por cada ítem hasta dos opciones si lo desea, indicando la marca y el precio por cada uno, así como el tiempo de entrega 
                                </div>
                            </div>


                            <div className="col-md-3">
                                <div className="form-group">
                                    <label className="control-label">
                                        Archivo
                                    </label>
                                    <label className={`form-control input-sm label-upload-file label-upload-file-enabled`} onClick={ () => this.props.displayModalAddFile(true, 'Adjuntar archivo', 'create')} >
                                        <i className="fa fa-upload"></i> { solicitud.getIn(['cotizaciones', 0, 'adjunto', 'file']) ? solicitud.getIn(['cotizaciones', 0, 'adjunto', 'file']).name : ' Adjuntar cotización' }
                                    </label>
                                </div>                             
                            </div>
                        </div>
                        
                        <div className="separator" />
                        <div className="separator" />

                        <table className="table table-condensed table-bordered table-striped table-sorted nowrap" id="table-tipo-moneda">
                            <thead>
                                <tr>
                                    <th style={{ maxWidth: '86%', padding:'0 10px' }}>Tipo de moneda:</th>
                                    <th style={{textAlign:'right'}}>
                                        <div style ={{alignItems:'flex-end'}} className="btn-group" role="group" aria-label="Basic outlined example">
                                            {
                                                divisas && divisas.map((d,i) => {
                                                    return (
                                                        <button key={`d[${i}]`} style={{borderRadius: '5px'}} type="button" className={ moneda == d.get('CODIGO') ? 'btn btn-primary' : 'btn btn-outline-primary' }>{ d.get('CODIGO') }</button>
                                                    );
                                                })
                                            }
                                        </div>
                                    </th>
                                </tr>
                            </thead>
                        </table>

                        <div className="row">

                            <div className="col-md-12">

                            <Box title={ `Cotizaciones` } onModal>
                                <div className="box-content" style={{ height: "Calc(100vh - 365px)", overflowX: 'hidden' }}>
                                
                                    <table className="table table-condensed table-bordered table-striped" id="comparativo-marcas">
                                        <thead> 
                                            <tr>
                                                <th>Descripción</th>   
                                                <th>Observaciones</th> 
                                                <th>Unidad</th> 
                                                <th>Cant.</th>                                       
                                                <th>Marca</th>
                                                <th>Vlr. Unitario</th>
                                                <th>IVA</th>
                                                <th>Vlr. con IVA</th>
                                                <th>Días hábiles de entrega</th>
                                                <th>No cotizar</th>
                                            </tr>  
                                        </thead>
                                        <tbody>
                                        {
                                            cotizaciones.filter(c => c.get('proveedor_id')).map((cotizacion, idx) => {                                                

                                                const cantidad = Number(cotizacion.getIn(['bienes', 0, 'cantidad_solicitada']))
                                                const cotizado_iva = Number(cotizacion.get('cotizado_iva'))
                                                const valor_total = cantidad * cotizado_iva              
                                                let isnew = true

                                                if (idx > 0) {
                                                    const idant = cotizaciones.getIn([(idx-1), 'bienes', 0, 'id'])
                                                    const idact = cotizacion.getIn(['bienes', 0, 'id'])
                                                    if (idant === idact) isnew = false
                                                }

                                                if (isnew) cont_items++
                                                const tipo = (cont_items%2)
                                                const style = {
                                                    backgroundColor: tipo === 1 ? '#efefef' : '#ffffff'
                                                }

                                                return <tr key={`cot[${cotizacion.get('id')}][${cotizacion.get('proveedor_id')}]`}>
                                                
                                                    {isnew && <Fragment>
                                                        <td rowSpan={2} style={style}><div style={{width:'150px'}}>{ cotizacion.getIn(['bienes', 0, 'descripcion']) }</div></td>
                                                        <td rowSpan={2} style={style}><div style={{width:'150px'}}>{ cotizacion.getIn(['bienes', 0, 'observaciones']) }</div></td>
                                                        <td rowSpan={2} style={style}><div style={{width:'50px'}}>{ cotizacion.getIn(['bienes', 0, 'unidad']) }</div></td>
                                                        <td rowSpan={2} style={style}><div style={{width:'50px'}}>{ cotizacion.getIn(['bienes', 0, 'cantidad_solicitada']) }</div></td> 
                                                    </Fragment>}


                                                    <td><input type="text" className="form-control input-sm" value={cotizacion.get('marca') || ''} onChange={ e => this.props.updateInputs(`modalSummaryCotizaciones.data.solicitud.cotizaciones.${idx}.marca`, e.target.value) } style={{ width: '100px'}} maxLength={500}/></td>
                                                    <td><input type="number" className="form-control input-sm" value={cotizacion.get('cotizado') || ''} onChange={ e => this.props.updateInputs(`modalSummaryCotizaciones.data.solicitud.cotizaciones.${idx}.cotizado`, e.target.value) } style={{ width: '100px'}}/></td>
                                                    <td><input type="number" className="form-control input-sm" value={cotizacion.get('iva') || ''} onChange={ e => this.props.updateInputs(`modalSummaryCotizaciones.data.solicitud.cotizaciones.${idx}.iva`, e.target.value) }  style={{ width: '50px'}}/></td>
                                                    <td><div style={{ width: '150px', textAlign: 'right'}}>{ valor_total ? formatcoin( valor_total, divisa.simbolo ) : formatcoin( 0, divisa.simbolo ) }</div></td>
                                                    <td><input type="number" className="form-control input-sm" value={cotizacion.get('tiempo_entrega') || '' } onChange={ e => this.props.updateInputs(`modalSummaryCotizaciones.data.solicitud.cotizaciones.${idx}.tiempo_entrega`, e.target.value) } style={{ width: '100px'}}/></td> 

                                                    <td style={{textAlign: 'center'}}>
                                                        <input type="checkbox" checked={cotizacion.get('no_cotizar') || false} onChange={ e => this.props.updateInputs(`modalSummaryCotizaciones.data.solicitud.cotizaciones.${idx}.no_cotizar`, e.target.checked)} disabled />
                                                    </td>


                                                </tr>

                                            })
                                        }
                                        </tbody>
                                    </table>
                                
                                </div>                            
                            </Box>
                            
                            
                            </div>
                        
                        
                        </div>





                    </div>
                </ModalBody>
                <ModalFooter>
                </ModalFooter>

            </Modal>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        modalSummaryCotizaciones: state.externoscotizaciones.get('modalSummaryCotizaciones'),
        divisas: state.common.getIn(['parametros', 'DIVISAS'])
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        showHideModalSummaryCotizaciones: (state) => dispatch(showHideModalSummaryCotizaciones(state)),
        registerSolicitudCotizaciones: (solicitud_id) => dispatch(registerSolicitudCotizaciones(solicitud_id)),
        updateInputs: (path, value) => dispatch(updateInputs(path, value))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ModalSummaryCotizaciones)



// WEBPACK FOOTER //
// ./src/components/ExternosCotizaciones/ModalSummaryCotizaciones.jsx